import { EyeOutlined, HeartOutlined, MessageOutlined } from "@ant-design/icons";
import { ReportMedia } from "@shared/lib/types/reports";
import { formatData } from "@shared/lib/utils/formatData";
import { Card, Flex, Space, Typography } from "antd";

const { Meta } = Card;
const { Text, Title } = Typography;

export function ReportMediaCard({ report }: { report: ReportMedia }) {
  return (
    <Card
      hoverable
      cover={
        <img
          alt="example"
          src={report.mediaUrl}
          style={{ height: 340, width: 340, objectFit: "cover" }}
        />
      }
      onClick={() => window.open(report.link, "_blank")}
      style={{ width: 340 }}
    >
      <Meta
        title={
          <Flex align="center" gap={20}>
            <div style={{ display: "grid", gap: 10 }}>
              <Space>
                <HeartOutlined />
                <Title level={5} style={{ margin: 0 }}>
                  {formatData(report?.mediaData?.likes, "0.0 a")}
                </Title>
              </Space>
              <Text type="secondary">Likes</Text>
            </div>
            <div style={{ display: "grid", gap: 10 }}>
              <Space>
                <MessageOutlined />
                <Title level={5} style={{ margin: 0 }}>
                  {formatData(report?.mediaData?.comments, "0.0 a")}
                </Title>
              </Space>
              <Text type="secondary">Comments</Text>
            </div>
            <div style={{ display: "grid", gap: 10 }}>
              <Space>
                <EyeOutlined />
                <Title level={5} style={{ margin: 0 }}>
                  {formatData(report?.mediaData?.views, "0.0 a")}
                </Title>
              </Space>
              <Text type="secondary">Views</Text>
            </div>
          </Flex>
        }
      />
    </Card>
  );
}
